/**
 * @generated SignedSource<<cd00187b1b5991877b4409ff485dbd4d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type legacyRedirectsDamViewerQuery$variables = Record<PropertyKey, never>;
export type legacyRedirectsDamViewerQuery$data = {
  readonly subscription: {
    readonly tools: {
      readonly isViewerEnabled: boolean;
    } | null;
  } | null;
};
export type legacyRedirectsDamViewerQuery = {
  response: legacyRedirectsDamViewerQuery$data;
  variables: legacyRedirectsDamViewerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "ZakekeSubscriptionTool",
  "kind": "LinkedField",
  "name": "tools",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isViewerEnabled",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "legacyRedirectsDamViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "legacyRedirectsDamViewerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ZakekeSubscription",
        "kind": "LinkedField",
        "name": "subscription",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "678d836cab159e167f2dbad5fb1bffcb",
    "id": null,
    "metadata": {},
    "name": "legacyRedirectsDamViewerQuery",
    "operationKind": "query",
    "text": "query legacyRedirectsDamViewerQuery {\n  subscription {\n    tools {\n      isViewerEnabled\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e94f4e958bd2fb0a19e50fb1e83ec765";

export default node;
